var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowWorksTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 68,
    viewBox: "0 0 80 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 34C0 15.2223 15.2223 0 34 0H46C64.7777 0 80 15.2223 80 34C80 52.7777 64.7777 68 46 68H34C15.2223 68 0 52.7777 0 34Z",
    fill: "#2F4E77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4362 34.5796C23.2973 34.2054 23.2973 33.7938 23.4362 33.4196C24.789 30.1394 27.0854 27.3347 30.0342 25.3611C32.9829 23.3876 36.4513 22.334 39.9995 22.334C43.5478 22.334 47.0162 23.3876 49.9649 25.3611C52.9137 27.3347 55.21 30.1394 56.5629 33.4196C56.7018 33.7938 56.7018 34.2054 56.5629 34.5796C55.21 37.8599 52.9137 40.6646 49.9649 42.6381C47.0162 44.6117 43.5478 45.6653 39.9995 45.6653C36.4513 45.6653 32.9829 44.6117 30.0342 42.6381C27.0854 40.6646 24.789 37.8599 23.4362 34.5796Z",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39C42.7614 39 45 36.7614 45 34C45 31.2386 42.7614 29 40 29C37.2386 29 35 31.2386 35 34C35 36.7614 37.2386 39 40 39Z",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowWorksTwo);
export default __webpack_public_path__ + "static/media/how-works-two.72b471490148e4b3f3d53ea67a3ea129.svg";
export { ForwardRef as ReactComponent };